define(["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.expose = expose;
  // @ts-check
  const inAmd = !!window.require;

  if (!inAmd) {
    /**
     * @type {any}
     * @param {string[]} deps
     * @param {(...modules: any[]) => void} callback
     */
    const require = function require(deps, callback) {
      const modules = deps.map(dep => {
        if (!(dep in window.require.modules)) {
          throw new Error("Unsupported dependency name: ".concat(dep));
        }

        return window.require.modules[dep];
      });
      callback(...modules);
    };

    require.modules = {};
    window.require = require;
  }
  /**
   * @param {string} name
   * @param {any} object
   */


  function expose(name, object) {
    if (!inAmd) {
      window.require.modules[name] = object;
    }
  }
});
//# sourceMappingURL=expose-modules.js.map